import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import { LANGUAGES as LANGS } from '../../i18n/languages';

import { ta } from '../../i18n/adminT';
const DOC_TYPES = [
  { key: 'privacy', label: 'Informativa privacy' },
  { key: 'security', label: 'Informativa sicurezza' },
];

const PLATFORMS = [
  { key: 'android', label: 'Android' },
  { key: 'ios', label: 'iOS (iPhone/iPad)' },
  { key: 'desktop', label: 'Computer desktop' },
];

export default function DocumentsManager() {
  const [docs, setDocs] = useState({}); // chiave "tipo:lingua" -> record
  const [error, setError] = useState('');
  const [uploading, setUploading] = useState(null); // "tipo:lingua" in corso di caricamento

  const [preview, setPreview] = useState({ android: false, ios: true, desktop: true });
  const [previewSaving, setPreviewSaving] = useState(false);
  const [previewSaved, setPreviewSaved] = useState(false);
  const [previewError, setPreviewError] = useState('');

  const load = async () => {
    const res = await api.getDocuments();
    const map = {};
    res.data.forEach((d) => { map[`${d.doc_type}:${d.lang}`] = d; });
    setDocs(map);
  };

  const loadPreviewConfig = async () => {
    try {
      const res = await api.getDocPreviewConfig();
      if (res.data) setPreview(res.data);
    } catch {
      // se non risponde, restano i valori di default già impostati
    }
  };

  useEffect(() => { load(); loadPreviewConfig(); }, []);

  const handleUpload = async (type, lang, file) => {
    if (!file) return;
    const slot = `${type}:${lang}`;
    setError('');
    setUploading(slot);
    try {
      await api.uploadDocument(type, lang, file);
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(null);
    }
  };

  const togglePreview = (platform) => {
    setPreviewSaved(false);
    setPreview((prev) => ({ ...prev, [platform]: !prev[platform] }));
  };

  const handleSavePreview = async () => {
    setPreviewError('');
    setPreviewSaving(true);
    try {
      await api.saveDocPreviewConfig(preview);
      setPreviewSaved(true);
    } catch (err) {
      setPreviewError(err.message);
    } finally {
      setPreviewSaving(false);
    }
  };

  return (
    <div>
      <h1 className="admin-page-title">{ta('Documenti privacy e sicurezza')}</h1>
      <p className="admin-page-subtitle">
        {ta('Carica una versione di ciascun documento per ogni lingua (italiano, inglese, rumeno). Il pannello utente mostra automaticamente quella corrispondente alla lingua selezionata dal visitatore; se manca la versione in quella lingua, viene mostrata quella italiana come ripiego.')}
      </p>

      {error && <div className="form-error">{error}</div>}

      <div className="admin-card">
        {DOC_TYPES.map(({ key: type, label }) => (
          <div key={type} style={{ marginBottom: 22 }}>
            <div style={{ fontWeight: 600, marginBottom: 10 }}>{ta(label)}</div>
            <div className="field-row" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
              {LANGS.map(({ key: lang, label: langLabel, flag }) => {
                const slot = `${type}:${lang}`;
                const doc = docs[slot];
                return (
                  <div key={lang} className="doc-status-row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 10 }}>
                    <div style={{ fontSize: '0.85rem', color: 'var(--muted-text)' }}>
                      {flag} {langLabel}
                      <br />
                      {doc ? `${ta('Caricato:')} ${doc.original_name}` : ta('Nessun documento caricato')}
                    </div>
                    <div className="upload-drop" style={{ padding: '10px 18px', width: '100%' }}>
                      <label htmlFor={`upload-${slot}`}>
                        {uploading === slot ? ta('Caricamento…') : doc ? ta('Sostituisci PDF') : ta('Carica PDF')}
                      </label>
                      <input
                        id={`upload-${slot}`}
                        type="file"
                        accept="application/pdf"
                        onChange={(e) => handleUpload(type, lang, e.target.files[0])}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="admin-card" style={{ maxWidth: 480 }}>
        <h3 style={{ marginBottom: 10 }}>{ta('Anteprima PDF nell\'app')}</h3>
        <p style={{ fontSize: '0.85rem', color: 'var(--muted-text)', marginBottom: 14 }}>
          {ta('Su alcuni dispositivi (tipicamente Android) l\'anteprima del PDF incorporata nel popup non si vede bene. Disattivandola per quel sistema operativo, il documento si apre automaticamente (senza dover toccare nulla) e viene subito segnato come letto; quando il visitatore chiude il documento e torna sull\'app, il popup si chiude da solo.')}
        </p>

        {previewError && <div className="form-error">{previewError}</div>}
        {previewSaved && (
          <div style={{ background: 'rgba(62,142,126,0.12)', color: 'var(--teal-green-dark)', borderRadius: 'var(--radius-control)', padding: '10px 14px', fontSize: '0.85rem', marginBottom: 16 }}>
            {ta('Impostazioni salvate.')}
          </div>
        )}

        {PLATFORMS.map(({ key, label }) => (
          <label key={key} className="checkbox-row">
            <input type="checkbox" checked={Boolean(preview[key])} onChange={() => togglePreview(key)} />
            <span>{ta(label)}</span>
          </label>
        ))}

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSavePreview}
          disabled={previewSaving}
          style={{ width: 'auto', padding: '10px 20px', marginTop: 6 }}
        >
          {previewSaving ? ta('Salvataggio…') : ta('Salva')}
        </button>
      </div>
    </div>
  );
}
